module.exports = __webpack_public_path__ + "img/sevak-team.82d76efc.png";